import { all } from 'redux-saga/effects';

import fetchInvoices from './fetchInvoices';

export default function* () {
    yield all([fetchInvoices()]);
}
